import * as olProj from 'ol/proj';
import * as jsPDF from 'jspdf'
import moment from "moment";
import {UE_LOGO, GEOSERVERHOST, CORSANYWHERE} from '../constants'
import MainStore from "../store/MainStore";


import {PRINT_DIM} from "../constants"
import React from "react";

class PrintService{

    constructor(refMap) {
        this.map = refMap;
        this.legende = [];
        this.geoserverApiUrl = MainStore.getState().AppReducer.geoserverApiUrl;
    }

    exportOptions(){
        return(
            {
                filter: function (element) {
                    var className = element.className || '';
                    return (
                        className.indexOf('ol-control') === -1 ||
                        className.indexOf('ol-scale') > -1 ||
                        (className.indexOf('ol-attribution') > -1 &&
                            className.indexOf('ol-uncollapsible'))
                    );
                },
            })
    };

    printScreenShot(refMap){

        const dim = PRINT_DIM.a6
        const resolution = 72
        const scale = 10
        const width = Math.round((dim[0] * resolution) / 25.4);
        const height = Math.round((dim[1] * resolution) / 25.4);
        let exprOptions = this.exportOptions();
        let size = refMap.getSize();
        let viewResolution = refMap.getView().getResolution();
        let scaleResolution = scale / olProj.getPointResolution(refMap.getView().getProjection(), resolution / 25.4, refMap.getView().getCenter());
        //exprOptions.width = width;
        //exprOptions.height= height;

        let promise = new Promise((resolve, reject)=>{

        refMap.once('rendercomplete', function (event) {

                /*
                 domtoimage.toPng(that.map.getViewport(), exprOptions)
                     .then((dataURL) => {
                         //console.log(dataURL);
                         that.props.updatePrintScreenCapture(dataURL)
                     });

                 */

                //const src = refMap.getTargetElement().getElementsByTagName('canvas')[0].toDataURL()
                let canvas = event.context.canvas;
                let srcData = canvas.toDataURL('image/jpeg');
                refMap.setSize(size);
                refMap.getView().setResolution(viewResolution);


                resolve(srcData)
        },)

        });

        let printSize = [width, height];
        refMap.setSize(printSize);
        refMap.updateSize();
        refMap.getView().setResolution(scaleResolution);



        refMap.renderSync();
        return promise
    }

    scaleReadeable(scale){
        switch(scale) {
            case '1':
                return '1:1000'
            case '2':
                return '1:2000'
            case '2.5':
                return '1:25000'
            case '3':
                return '1:3000'
            case '4':
                return '1:4000'
            case '5':
                return '1:50000'
            case '10':
                return '1:10000'
            case '25':
                return '1:250000'
            default :
                return ''
        }
    }

    printMap(refMap, format, resolution, scale) {

        document.body.style.cursor = 'progress';

        this.format = format.toUpperCase();
        this.legendeRapport = 1;
        this.typoRapport = 1;

        (format=='a5')?this.legendeRapport=0.71:(format=='a3')?this.legendeRapport = 1.43:this.legendeRapport=1 ;// 1 si A4on double en A3 et 1/2 en A5
        (format=='a5')?this.typoRapport=0.71:this.typoRapport=1 ;// si A5 small typo

        this.scale = this.scaleReadeable(scale);
        this.numScale = Number(scale)
        let dim = PRINT_DIM[format];
        let width = Math.round(dim[0] * resolution / 25.4);
        let height = Math.round(dim[1] * resolution / 25.4);
        let size = refMap.getSize();
        let viewResolution = refMap.getView().getResolution();
        let scaleResolution = scale / olProj.getPointResolution(refMap.getView().getProjection(), resolution / 25.4, refMap.getView().getCenter());

        let that = this;
        refMap.once('rendercomplete', function(event) {
            let canvas = event.context.canvas;
            let data = canvas.toDataURL('image/jpeg');
            let pdf = new jsPDF('landscape', undefined, format);
            pdf.addImage(data, 'JPEG', 0, 0, dim[0], dim[1]);

            that.buildLegende()
            that.buildCartouche(pdf,  that.legendeRapport, that.typoRapport);

            pdf.save('map.pdf');
            // Reset original map size
            refMap.setSize(size);
            refMap.getView().setResolution(viewResolution);
            refMap.updateSize();
            document.body.style.cursor = 'auto';
        });

        // Set print size
        let printSize = [width, height];
        refMap.setSize(printSize);
        refMap.getView().setResolution(scaleResolution);
        refMap.updateSize();

    }

    buildLegende(){
        let that = this
        let layers = this.map.getLayers().getArray();
        let copyLayers = layers.slice();
        _.reverse(copyLayers);
        copyLayers = _.uniq(copyLayers);
        copyLayers.map((item, index)=>{
                that.buildPostLegende(item)
            })
    }

    buildPostLegende(layer){
        this.legende.push({"name" : layer.get('name')});
    }

    buildCartouche(doc,fact=1, typo = 1){

        doc.setFillColor(255, 255, 255)
        doc.setDrawColor(170)
        doc.rect(250*fact, 0*fact, 48*fact, 210*fact, 'F')//base

        doc.rect(250*fact, 135*fact, 48*fact, 10*fact, 'FD')
        doc.rect(250*fact, 145*fact, 48*fact, 10*fact, 'FD')
        doc.rect(250*fact, 155*fact, 48*fact, 20*fact, 'FD')
        doc.rect(250*fact, 185*fact, 48*fact, 35*fact, 'FD')
        doc.line(272*fact, 135*fact, 272*fact, 155*fact)

        doc.setFillColor(100, 100, 100)
        doc.rect(250*fact, 0*fact, 48*fact, 35*fact, 'FD') // fond title
        doc.setFillColor(200, 200, 200)
        doc.rect(250*fact, 0*fact, 48*fact, 28*fact, 'FD') // fond title clair


        doc.setFontSize(8
        )
        doc.setFillColor(170, 170, 170)
        doc.rect(5*fact, 200*fact, 64*fact, 4*fact, 'FD')
        doc.setTextColor(0)

        //---------- legal
        doc.setFontType('normal')
        doc.setFontSize(7*typo)
        doc.setTextColor(255)
        doc.text(6.5*fact, 203*fact, 'Note : Le présent document n\'a aucune portée légale')
        doc.setFontSize(8)

        //------com label
        let comLabel = MainStore.getState().MapReducer.currentComLabel
        if(comLabel){

            doc.setTextColor(255)
            doc.setFontSize(9*typo)
            doc.text(255*fact, 25*fact, comLabel)
        }
        //-----title
        doc.setTextColor(255)
        doc.setFontType('bold')
        doc.setFontSize(10*typo)
        doc.text(255*fact, 33*fact, 'PLAN DE SITUATION')

        //---source
        doc.setTextColor(130,130,130)
        doc.setFontType('normal')
        doc.setFontSize(5.5*typo)
        doc.text(295*fact, 129*fact, 'Source:', {"align": "right"})
        const date = 'Cadastre Etalab:'+moment().format('YYYY');
        doc.text(295*fact, 131*fact, date, {"align": "right"})
        doc.text(295*fact, 133*fact, 'Fond Satellitaire : IGN', {"align": "right"})

        //---info
        doc.setTextColor(50,50,50)
        doc.setFontType('normal')
        doc.setFontSize(8*typo)
        doc.text(253*fact, 140*fact, 'Format :\n '+this.format)
        doc.text(253*fact, 150*fact, 'Echelle :\n '+this.scale)
        doc.text(273*fact, 140*fact, 'Date :\n '+moment().format('DD/MM/YYYY'))
        doc.text(273*fact, 150*fact, 'Projection :\n EPSG:2154')

        //---scale
        doc.setDrawColor(100,100,100)

        doc.line(260*fact, 171*fact, 280*fact, 171*fact)
        doc.line(260*fact, 169*fact, 260*fact, 169*fact)
        doc.line(280*fact, 169*fact, 280*fact, 169*fact)
        doc.line(270*fact, 171*fact, 270*fact, 170*fact)
        doc.setTextColor(50,50,50)
        doc.setFontSize(7*typo)
        doc.text(260*fact, 170*fact, '0')
        doc.text(280*fact, 170*fact,    (this.numScale*10)*2+'m')//2 cm sont representés !!


        //----logo
        const logoRapport = 22/18
        doc.addImage(UE_LOGO, 251*fact, 189*fact, 14,14*logoRapport);
        doc.setTextColor(130,130,130)
        doc.setFontType('bold')
        doc.setFontSize(9*typo)
        doc.text(267*fact, 190*fact, 'Urba-Earth')
        doc.setFontType('normal')
        doc.setFontSize(4.5*typo)
        doc.text(267*fact, 193*fact, 'Système dInformation Géographique\nUrbanisme et aménagement du territoire')
        doc.setFontSize(4*typo)
        doc.text(267*fact, 198*fact, '14 rue conventionnel Chiappe\n20000 Ajaccio\ncantact@urba-earth.com\nWeb : https://urba-earth.com\nTel.:06 09 81 50 77')

        //----Legende Title
        doc.setTextColor(100)
        doc.setFontType('bold')
        doc.setFontSize(8*typo)
        doc.text(255*fact, 41*fact, 'LEGENDE')

        //---legende
        doc.setTextColor(100)
        doc.setFontType('normal')
        doc.setFontSize(7*typo)

        let startX = 255*fact
        let startY = 50*fact

        this.legende.map((item,index)=>{
            let spaceCount=1;
            if(index<14){
                if (item.name && item.name.indexOf(':')>0){
                    const geoServerURL = MainStore.getState().AppReducer.geoserverApiUrl;
                    //const jsInfoUrl = CORSANYWHERE+this.geoserverApiUrl+'?REQUEST=GetLegendGraphic&VERSION=1.0.0&format=application/json&LAYER='+item.name
                    const jsInfoUrl =  geoServerURL+'?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=application/json&LAYER='+item.name;
                    $.ajax({
                        type: "POST",
                        url: jsInfoUrl,
                        dataType: 'jsonp',
                        jsonpCallback: 'getJson',
                        success: function (data) {
                            //console.log(data);
                            spaceCount = data.Legend[0].rules.length;
                        },
                    });
                   /*
                    axios.get(jsInfoUrl,{
                        headers: {
                            'INFO_FORMAT': 'text/javascript',
                            'format_options': 'callback: getJson'
                        }
                        ,
                    }).then(result=>{
                        spaceCount = result.data.Legend[0].rules.length;
                    })

                    */

                    let img = new Image();
                    const imgURL = geoServerURL+'?REQUEST=GetLegendGraphic&VERSION=1.0.0&FORMAT=image/png&WIDTH=20&HEIGHT=20&LAYER='+item.name+'&legend_options=fontName:Times%20New%20Roman;dpi:91;fontAntiAliasing:true;fontColor:0x000033;fontSize:5'
                    img.src = imgURL;
                    startY+=6*spaceCount
                    doc.addImage(img, "PNG", startX, startY);
                }else{
                    //doc.addImage(UE_LOGO, startX, startY, 5,5);
                    //doc.text(startX+7, startY+3, (item.name)?item.name:'Couche');
                    //startY+=6
                }

            }
        })
    }
}


export default PrintService
